export { InstanceDashboardRedirect as default } from 'component/navigation/instance';
